// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"aead4afb","795":"b850d497"}[chunkId] + ".chunk.js";
};